import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Trans } from "@lingui/macro";
import { Button, ControlGroup } from "@conserveit/blocks";
import { MentionBox, MsgAlert, AttachmentsPreview } from "../";
import { Wrapper, CommentActions } from "./AddCommentBox.styles";

export default class AddCommentBox extends PureComponent {
  static propTypes = {
    attachments: PropTypes.array,
    onUploadAttachment: PropTypes.func.isRequired,
    handleRemoveAttachment: PropTypes.func.isRequired,
    onCommentTextChange: PropTypes.func.isRequired,
    isCommentPosting: PropTypes.bool,
    completingIssue: PropTypes.bool,
    usernameList: PropTypes.array,
    updateTaggingList: PropTypes.func,
    value: PropTypes.string.isRequired,
    user: PropTypes.object,
  };

  render() {
    const errorMessage = this.props.error
      ? "There was an error in submit."
      : "";

    return (
      <Wrapper data-cy="AddCommentBox">
        <div id="formControlsTextarea">
          <MsgAlert type="error" message={errorMessage} />

          <AttachmentsPreview
            attachments={this.props.attachments}
            handleRemoveAttachment={this.props.handleRemoveAttachment}
            isRemoveVisible={
              !this.props.isCommentPosting && !this.props.completingIssue
            }
          />

          <MentionBox
            usernameList={this.props.usernameList}
            updateTaggingList={this.props.updateTaggingList}
            handleCommentTextChange={this.props.onCommentTextChange}
            value={this.props.value}
          />
        </div>
        <CommentActions>
          <Button
            wafer
            appearance="subdued"
            onClick={this.props.onUploadAttachment}
          >
            <Trans id="issue_pane.attach_file">Attach File</Trans>
          </Button>
          <ControlGroup extraTight>
            {this.props.onCancel && (
              <Button thin appearance="plain" onClick={this.props.onCancel}>
                <Trans id="issue_pane.close">Close</Trans>
              </Button>
            )}
            <Button
              primary
              thin
              onClick={this.props.handleAddComment}
              disabled={this.props.disabled}
              type="submit"
              data-cy="AddCommentBox-AddComment"
            >
              <Trans id="issue_pane.add_comment">Add Comment</Trans>{" "}
              {this.props.isCommentPosting}
            </Button>
          </ControlGroup>
        </CommentActions>
      </Wrapper>
    );
  }
}
